import React, { useState } from "react";

import {
  Link,
  useLocation
} from "react-router-dom";

import {
  LayoutDashboard,
  Box,
  PlusCircle,
  Users,
  ShoppingCart,
  FileText,
  LogOut,
  PersonStanding,
  History,
  Menu,
  X
} from "lucide-react";

import logo from "../assets/logo.png";

const Sidebar = () => {

  const location = useLocation();

  const [isOpen, setIsOpen] = useState(false);

  // =========================================
  // LOGOUT
  // =========================================

  const handleLogout = () => {

    localStorage.removeItem("token");
    localStorage.removeItem("user");

    window.location.replace("/login");

  };

  // =========================================
  // MENU
  // =========================================

  const menu = [

    {
      title: "Dashboard",
      path: "/",
      icon: LayoutDashboard
    },

    {
      title: "Create Rental",
      path: "/rental",
      icon: ShoppingCart
    },

    {
      title: "Rental History",
      path: "/rental-history",
      icon: History
    },

    {
      title: "Credit Customers",
      path: "/credit-customers",
      icon: PersonStanding
    },

    {
      title: "Customers",
      path: "/customers",
      icon: Users
    },

    {
      title: "Products",
      path: "/products",
      icon: Box
    },

    {
      title: "Add Product",
      path: "/add-product",
      icon: PlusCircle
    },

    {
      title: "Quotation",
      path: "/quotation",
      icon: FileText
    },

    {
      title: "Quotation History",
      path: "/quotation-history",
      icon: History
    }

  ];

  return (
    <>

      {/* ========================================= */}
      {/* MOBILE MENU BUTTON */}
      {/* ========================================= */}

      <button
        onClick={() => setIsOpen(true)}
        className="fixed top-4 left-4 z-[60] lg:hidden bg-indigo-600 text-white p-3 rounded-xl shadow-lg"
      >
        <Menu size={22} />
      </button>

      {/* ========================================= */}
      {/* OVERLAY */}
      {/* ========================================= */}

      {isOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-40 lg:hidden"
          onClick={() => setIsOpen(false)}
        />
      )}

      <div
        className={`
          fixed top-0 left-0 h-screen w-[280px]
          overflow-y-auto sidebar-scroll
          bg-gradient-to-b from-[#172554] via-[#1E1B4B] to-[#111827]
          border-r border-white/10
          flex flex-col
          z-50
          transform transition-transform duration-300
          ${isOpen ? "translate-x-0" : "-translate-x-full"}
          lg:translate-x-0
        `}
      >

        {/* MOBILE CLOSE BUTTON */}

        <button
          onClick={() => setIsOpen(false)}
          className="absolute top-5 right-5 text-white lg:hidden"
        >
          <X size={24} />
        </button>

        {/* ========================================= */}
        {/* LOGO */}
        {/* ========================================= */}

        <div className="sidebar-logo border-b border-white/10">

          <div className="logo-box flex flex-col items-center justify-center py-6">

            <img
              src={logo}
              alt="logo"
              className="logo-img max-w-[250px] object-contain"
            />

          </div>

        </div>

        {/* ========================================= */}
        {/* MENU */}
        {/* ========================================= */}

        <div className="flex-1 px-5 py-6">

          <p className="text-xs uppercase tracking-[3px] text-indigo-200/40 font-semibold px-3 mb-4">
            Main Menu
          </p>

          <ul className="space-y-2">

            {menu.map((item, i) => {

              const isActive =
                location.pathname === item.path;

              const Icon =
                item.icon;

              return (

                <li key={i}>

                  <Link
                    to={item.path}
                    onClick={() => setIsOpen(false)}
                    className={`group flex items-center gap-4 px-4 py-3 rounded-2xl transition-all duration-200

                    ${
                      isActive

                        ? "bg-gradient-to-r from-[#D4B06A] to-[#E7C98A] text-[#111827] shadow-lg"

                        : "text-gray-300 hover:bg-white/10 hover:text-white"
                    }`}
                  >

                    <div
                      className={`w-10 h-10 rounded-xl flex items-center justify-center transition-all

                      ${
                        isActive
                          ? "bg-black/10"
                          : "bg-white/5 group-hover:bg-white/10"
                      }`}
                    >

                      <Icon size={18} />

                    </div>

                    <span className="font-medium text-sm tracking-wide">
                      {item.title}
                    </span>

                  </Link>

                </li>

              );

            })}

          </ul>

        </div>

        {/* ========================================= */}
        {/* LOGOUT */}
        {/* ========================================= */}

        <div className="p-5 border-t border-white/10">

          <button

            onClick={handleLogout}

            className="w-full flex items-center justify-center gap-3 bg-red-500 hover:bg-red-600 text-white py-3 rounded-2xl font-medium transition-all"

          >

            <LogOut size={18} />

            Logout

          </button>

        </div>

      </div>

    </>
  );

};

export default Sidebar;